import { Controller } from "@hotwired/stimulus";

const COMMISSION_TYPES = {
  sales: {
    title: "販売手数料",
    titleEn: "Sales Fees",
  },
  purchase: {
    title: "購入手数料",
    titleEn: "Purchase Fees",
  },
};

export default class extends Controller {
  static targets = ["payer", "title", "titleEn"];
  static values = {
    promoter: String,
  };

  change() {
    this.updateTitle();
  }

  updateTitle() {
    if (this.isCommissionType("sales") && this.paidByUser()) {
      this.setCommissionTypeTitle("purchase");
      return;
    }

    if (this.isCommissionType("purchase") && this.paidByPromoter()) {
      this.setCommissionTypeTitle("sales");
    }
  }

  isCommissionType(type) {
    const commission = COMMISSION_TYPES[type];

    return this.titleTarget.value == commission.title && this.titleEnTarget.value == commission.titleEn;
  }

  setCommissionTypeTitle(type) {
    const commission = COMMISSION_TYPES[type];

    this.titleTarget.value = commission.title;
    this.titleEnTarget.value = commission.titleEn;
  }

  paidByPromoter() {
    return this.checkedPayer?.value == this.promoterValue;
  }

  paidByUser() {
    return !!this.checkedPayer && !this.paidByPromoter();
  }

  get checkedPayer() {
    return this.payerTargets.find((radio) => radio.checked);
  }
}
